import styled from '@emotion/styled'
import { Container, Button, Paper, Box, Grid } from '@mui/material'
import { colors } from '../../../../Themes/Colors'

export const PageContainer = styled(Container)`
  padding: 24px;
  margin-bottom: 48px;
`

export const HeaderSection = styled.div`
  margin-bottom: 32px;
`

export const BackButton = styled(Button)`
  margin-bottom: 16px;
  color: ${colors.darkGrey};
  &:hover {
    background-color: ${colors.lightGrey};
  }
`

export const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: ${colors.greyBlue};
`

export const Subtitle = styled.p`
  font-size: 16px;
  color: ${colors.mediumGrey};
  margin: 0;
`

export const InfoCard = styled(Paper)`
  background: #ffffff;
  border: 1px solid ${colors.lightGrey};
  border-radius: 8px;
  margin-bottom: 24px;
  overflow: hidden;
`

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${colors.greyBlue};
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: ${colors.mediumGrey};
    font-size: 20px;
  }
`

export const ProfileSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'confirmed',
})<{ confirmed?: boolean }>`
  padding: 20px;
  background: ${(props) => (props.confirmed ? '#f0f9ff' : '#f8f8f8')};
  border-radius: 8px;
  border: 1px solid
    ${(props) => (props.confirmed ? '#e3f2fd' : colors.lightGrey)};
  height: 100%;
`

export const ProfileGrid = styled(Grid)`
  margin-top: 16px;
`

export const ProfileColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ProfileLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.darkGrey};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`

export const ProfileContent = styled.div`
  font-size: 14px;
  color: ${colors.greyBlue};
  line-height: 1.6;
  margin-bottom: 16px;
`

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const DataSection = styled(Paper)`
  background: #ffffff;
  border: 1px solid ${colors.lightGrey};
  border-radius: 8px;
  margin-bottom: 16px;
  overflow: hidden;
`

export const DataSectionHeader = styled.div`
  padding: 16px 24px;
  background: #fafafa;
  border-bottom: 1px solid ${colors.lightGrey};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #f5f5f5;
  }
`

export const DataContent = styled.div`
  padding: 24px;
`

export const JSONBlock = styled.pre`
  background: #f5f5f5;
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;
  padding: 16px;
  font-size: 12px;
  overflow-x: auto;
  margin: 0;
  font-family: 'Monaco', 'Consolas', 'Courier New', monospace;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`

export const ErrorContainer = styled.div`
  text-align: center;
  padding: 48px 24px;
  color: ${colors.red};
`

export const EmptyState = styled.div<{ small?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${(props) => (props.small ? '24px' : '48px')};
  text-align: center;
  color: ${colors.mediumGrey};
`

export const RefreshButton = styled(Button)`
  background-color: ${colors.resiliaBlue};
  color: white;
  &:hover {
    background-color: #1976d2;
  }
`

// Remove unused exports from old design
export const LinkButton = styled.div`
  display: none;
`

export const NonprofitProfileContainer = styled.div`
  display: none;
`

export const PageHeader = styled.div`
  display: none;
`

export const SectionHeader = styled.div`
  display: none;
`

export const SubSectionHeader = styled.div`
  display: none;
`

export const TagList = styled.div`
  display: none;
`

export const ToggleButtonContainer = styled.div`
  display: none;
`

export const StyledCollapse = styled.div`
  display: none;
`
